export default __webpack_public_path__ + "static/media/aws_educate.fa290423.jpeg";